<template>
    <div>
        <!--导航栏-->
        <van-nav-bar
                title="商户进件"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        />
        <!--导航栏-->
        <div style="margin-top: 1.5rem">
            <van-empty description="正在开发" />
        </div>
    </div>

</template>

<script>
    export default {
        name: "umpayer",
        methods: {
            onClickLeft() {
                this.$router.push("/Gangway");
            }
        }
    }
</script>

<style scoped>

</style>